import React, { useState } from "react";
import Tabs from "../../../../componentsUI/estructura/tabs/Tabs.js";

import AgregarProductoBomForm from "./creacionProductoBom.js";
import CrearProductoForm from "./creacionProducto.js";
import EditarProductoForm from "./edicionProducto.js";


export default function ParametrosProductos() {

  const [productoCodigo, setProductoCodigo] = useState(null);

  const configuracionModuloTabs = [
    {
      id: "producto_linea",
      label: "Crear Producto",
      content: (
        <CrearProductoForm 
          onProductoCreado={(codigo) => setProductoCodigo(codigo)} 
        />
      ),
    },
    {
      id: "producto_bom",
      label: "Crear insumos",
      content: (
        <AgregarProductoBomForm 
          productoCodigo={productoCodigo} 
        />
      ),
    },{
      id: "editar",
      label: "Editar Productos",
      content: (
        <EditarProductoForm 
          productoCodigo={productoCodigo} 
        />
      ),
    },
    
  ];

  return (
    <Tabs
      tabs={configuracionModuloTabs}
      defaultTabId="producto_linea"
    />
  );
}